(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/assets/javascripts/start.js') >= 0) return;  svs.modules.push('/modules/poker-react/assets/javascripts/start.js');
"use strict";


const PokerRouter = svs.poker_react.components.PokerRouter;
ReactDOM.render(React.createElement(PokerRouter, null), document.getElementById('poker-container'));

 })(window);